import angular from 'angular';
import feedbackComponent from './feedback.component';

export default angular.module('common.feedback', [])
  .component('feedback', feedbackComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/common/feedback/feedback.module.js